const STRINGS = {
  it: {
    tagline: "La bacheca dei bisogni",
    need: "Ho bisogno", help: "Posso aiutare",
    myRequests: "Le mie richieste", activity: "Attività",
    messages: "Messaggi", myAvailabilities: "Le mie disponibilità",
    profile: "Il mio profilo", settings: "Impostazioni", zone: "Zona",
    howItWorks: "Come funziona", logout: "Esci", login: "Accedi", register: "Registrati",
    publish: "Pubblica una richiesta", makeAvailable: "Mi rendo disponibile",
    iKnowSomeone: "Conosco chi può farlo", translate: "Traduci",
    shareContacts: "Condividi i miei contatti", report: "Segnala",
    open: "Aperta", withAvailabilities: "Con disponibilità", contact: "Contatto avviato",
    resolved: "Risolta", closed: "Chiusa", expired: "Scaduta",
    today: "Oggi", thisWeek: "In settimana", whenever: "Quando capita",
    online: "Online", allCountry: "Tutto il paese", enlarge: "Allarga la zona",
    beFirst: "Sii il primo", youAreAvailable: "Sei disponibile",
    footer: "FYDATE — La bacheca dei bisogni",
    disclaimer: "FYDATE mette solo in contatto le parti: nessun pagamento, nessuna trattativa e nessuna commissione passano dall'app.",
    private: "Privato", company: "Azienda", entity: "Ente",
    availableCount: "disponibili", noRequests: "Nessuna richiesta in questa zona.",
    send: "Invia", save: "Salva", cancel: "Annulla", back: "Indietro",
  },
  en: {
    tagline: "The board of needs",
    need: "I need", help: "I can help",
    myRequests: "My requests", activity: "Board",
    messages: "Messages", myAvailabilities: "My offers",
    profile: "My profile", settings: "Settings", zone: "Zone",
    howItWorks: "How it works", logout: "Log out", login: "Sign in", register: "Sign up",
    publish: "Post a request", makeAvailable: "I'm available",
    iKnowSomeone: "I know someone", translate: "Translate",
    shareContacts: "Share my contacts", report: "Report",
    open: "Open", withAvailabilities: "With offers", contact: "Contact started",
    resolved: "Resolved", closed: "Closed", expired: "Expired",
    today: "Today", thisWeek: "This week", whenever: "Anytime",
    online: "Online", allCountry: "Whole country", enlarge: "Widen the area",
    beFirst: "Be the first", youAreAvailable: "You're available",
    footer: "FYDATE — The needs board",
    disclaimer: "FYDATE only connects people: no payments, no negotiation and no commission go through the app.",
    private: "Private", company: "Company", entity: "Public body",
    availableCount: "offers", noRequests: "No requests in this area.",
    send: "Send", save: "Save", cancel: "Cancel", back: "Back",
  },
};

export function makeT(lang) {
  const dict = STRINGS[lang] || STRINGS.en;
  return (key) => dict[key] ?? STRINGS.it[key] ?? key;
}

export const LANGUAGES = [
  { code: "it", label: "Italiano" },
  { code: "en", label: "English" },
  { code: "de", label: "Deutsch" },
  { code: "fr", label: "Français" },
  { code: "es", label: "Español" },
];

export function catName(cat, lang) {
  if (!cat) return "";
  return (cat.names && (cat.names[lang] || cat.names.it || cat.names.en)) || cat.slug;
}
